import { render } from "./ReviewSentRequestQuestion.vue?vue&type=template&id=480063fb&scoped=true&ts=true"
import script from "./ReviewSentRequestQuestion.vue?vue&type=script&lang=ts"
export * from "./ReviewSentRequestQuestion.vue?vue&type=script&lang=ts"

import "./ReviewSentRequestQuestion.vue?vue&type=style&index=0&id=480063fb&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480063fb"]])

export default __exports__